import { CreateEventDto, EventType, UpdateEventDto } from "../../sdk"

export interface EventDto {
  id: string
  userIds: string[]
  institutionIds: string[]
  type: EventType
  title: string
  description?: string
  startDate: string
  endDate: string
  hlthyId?: string
  metadata?: Record<string, any>
  createdAt: string
  updatedAt: string
}

export enum EventsActionTypes {
  GET_EVENTS_REQUEST = '@@events/GET_EVENTS_REQUEST',
  GET_EVENTS_SUCCESS = '@@events/GET_EVENTS_SUCCESS',
  GET_EVENTS_FAILURE = '@@events/GET_EVENTS_FAILURE',

  CREATE_EVENT_REQUEST = '@@events/CREATE_EVENT_REQUEST',
  CREATE_EVENT_SUCCESS = '@@events/CREATE_EVENT_SUCCESS',
  CREATE_EVENT_FAILURE = '@@events/CREATE_EVENT_FAILURE',

  UPDATE_EVENT_REQUEST = '@@events/UPDATE_EVENT_REQUEST',
  UPDATE_EVENT_SUCCESS = '@@events/UPDATE_EVENT_SUCCESS',
  UPDATE_EVENT_FAILURE = '@@events/UPDATE_EVENT_FAILURE',

  DELETE_EVENT_REQUEST = '@@events/DELETE_EVENT_REQUEST',
  DELETE_EVENT_SUCCESS = '@@events/DELETE_EVENT_SUCCESS',
  DELETE_EVENT_FAILURE = '@@events/DELETE_EVENT_FAILURE',
}

export interface GetEventsRequest {
  type: typeof EventsActionTypes.GET_EVENTS_REQUEST
}

interface GetEventsSuccess {
  type: typeof EventsActionTypes.GET_EVENTS_SUCCESS
  response: EventDto[]
}

interface GetEventsFailure {
  type: typeof EventsActionTypes.GET_EVENTS_FAILURE
  errorMsg: string
}

export interface CreateEventRequest {
  type: typeof EventsActionTypes.CREATE_EVENT_REQUEST
  data: CreateEventDto
}

interface CreateEventSuccess {
  type: typeof EventsActionTypes.CREATE_EVENT_SUCCESS
  response: EventDto
}

interface CreateEventFailure {
  type: typeof EventsActionTypes.CREATE_EVENT_FAILURE
  errorMsg: string
}

export interface UpdateEventRequest {
  type: typeof EventsActionTypes.UPDATE_EVENT_REQUEST
  id: string
  data: UpdateEventDto
}

interface UpdateEventSuccess {
  type: typeof EventsActionTypes.UPDATE_EVENT_SUCCESS
  response: EventDto
}

interface UpdateEventFailure {
  type: typeof EventsActionTypes.UPDATE_EVENT_FAILURE
  errorMsg: string
}

export interface DeleteEventRequest {
  type: typeof EventsActionTypes.DELETE_EVENT_REQUEST
  id: string
}

interface DeleteEventSuccess {
  type: typeof EventsActionTypes.DELETE_EVENT_SUCCESS
}

interface DeleteEventFailure {
  type: typeof EventsActionTypes.DELETE_EVENT_FAILURE
  errorMsg: string
}

export interface EventsState {
  all: EventDto[]
  errorMsg: string
  loading: boolean
}

export type EventsActionType =
  GetEventsRequest |
  GetEventsSuccess |
  GetEventsFailure |
  CreateEventRequest |
  CreateEventSuccess |
  CreateEventFailure |
  UpdateEventRequest |
  UpdateEventSuccess |
  UpdateEventFailure |
  DeleteEventRequest |
  DeleteEventSuccess |
  DeleteEventFailure
